export const COMPLETIONS = 'COMPLETIONS';
export const COMPLETIONS_SUCCESS = 'COMPLETIONS_SUCCESS';
export const COMPLETIONS_FAILED = 'COMPLETIONS_FAILED';

export const REPORTS = 'REPORTS';
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS';
export const REPORTS_FAILED = 'REPORTS_FAILED';